import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import UsersService from "@velocity-ehs/user-utils-module";
import {
  getPagination,
  PaginationQueryObject,
  QuerySort,
} from "../components/supportFunctions/graphql/Queries";
import { gql, useQuery } from "@apollo/client";

function formatParams(params: any) {
  let querySort: QuerySort = null;

  if (params.sortField && params.sortOrder) {
    querySort = {
      sortField: params.sortField,
      sortDirection: params.sortOrder,
    } as QuerySort;
  }

  let pagination: PaginationQueryObject = getPagination(
    params.page + 1,
    params.rows,
    querySort
  );

  const filter = {
    and: {
      customerId: UsersService.customer?.id || undefined,
      name: params.filters.name?.value || undefined,
    },
  };

  return { filter, pagination };
}

const GET_CONTRACTING_COMPANIES = gql`
  query getContractingCompanies(
    $filter: ContractingCompanyFilter
    $paginationInput: PaginationInput
  ) {
    contractingCompanies(filter: $filter, paginationInput: $paginationInput) {
      items {
        id
        name
      }
      pageInfo {
        pageNumber
        pageSize
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

const useGetPaginatedContractingCompanies = (params?: any) => {
  const { showSnackbar } = useSnackbarActionContext();

  const { filter, pagination } = formatParams(params);

  const result = useQuery(GET_CONTRACTING_COMPANIES, {
    variables: {
      filter,
      paginationInput: pagination,
    },
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    contractingCompanies: result.data?.contractingCompanies.items || [],
    pagination: result.data?.contractingCompanies.pageInfo || {},
  };
};

export { useGetPaginatedContractingCompanies, GET_CONTRACTING_COMPANIES };
